import { IPIconButton, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall, leftArrowIcon, rightArrowIcon } from 'globalStyles';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export interface IArrayViewerDataProps {
  data: unknown;
}

interface IArrayViewerProps {
  data: unknown[];
  child: FunctionComponent<IArrayViewerDataProps>;
}

const ArrayViewer = (props: IArrayViewerProps) => {
  const { t } = useTranslation('translation');
  const [page, setPage] = React.useState<number>(1);

  if (props.data.length === 0) return null;
  if (props.data.length === 1) return <props.child data={props.data[0]} />;

  return (
    <IPStack verticalFill tokens={globalStackTokensGapSmall}>
      <IPStack.Item>
        <IPStack horizontal verticalAlign="center">
          <IPStack.Item>
            <IPIconButton iconProps={leftArrowIcon} onClick={() => setPage(page - 1)} disabled={page === 1} />
          </IPStack.Item>
          <IPStack.Item>
            <IPIconButton
              iconProps={rightArrowIcon}
              onClick={() => setPage(page + 1)}
              disabled={page === props.data.length}
            />
          </IPStack.Item>
          <IPStack.Item styles={{ root: { paddingLeft: 5 } }}>
            <IPText>{t('translation:General.List.PageIndex', { nr: page, count: props.data.length })}</IPText>
          </IPStack.Item>
        </IPStack>
      </IPStack.Item>
      <IPStack.Item grow>
        <props.child data={props.data[page - 1]} />
      </IPStack.Item>
    </IPStack>
  );
};

export default ArrayViewer;
